module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAASCAYAAAC0EpUuAAAABHNCSVQICAgIfAhkiAAAAPxJREFUOI2lk10VwjAMhTMUVMIkzAGVgIQ5AAfggDnYHDAHDAXMAZWAg4+HZecUKF2AvPSc9Obm5yYiGQM8cGKyANyAI+BycTnCDuiBKvI5oNYEVS4+RdgATea/VOLSSlgCgwHngd5KegBqIzak5rtKYL2IBFMFE+5ttinSvy1FOoiITYAJNy6iZmUNuI1ZKA1ogDbzX321UlFgB5wBH/kcsP1p+SMSr1c1W9AufjvTf6xIOXVWaxHZiIiTSeVZ6bu+fVEUl8UMKsAZGLVN/9qqYmqdeQD2yXGoAC0wxMIYinB61uHptHUvr8DOSvaBfASOs2P8proF8g7YPQD0aCH5LRQLdwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/user.png
// module id = 2661
// module chunks = 0